import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const Spinner = ({ className }) => {
  const spinnerClassNames = classNames('spinner', className);

  return (
    <svg className={spinnerClassNames}>
      <circle cx="50%" cy="50%" r="45%" className="spinner__circle" />
      <circle cx="50%" cy="50%" r="45%" className="spinner__indicator" />
    </svg>
  );
};

Spinner.propTypes = {
  className: PropTypes.string
};

export default Spinner;
